import RefClient from 'ref-client-core';
import addViaPlugin from './addViaContextMenu';
import tracePlugin from './trace';
import viaFieldsPlugin from './viaFields';

RefClient.formViewsPlugin.register('viaFields', viaFieldsPlugin);
RefClient.formViewsPlugin.register('tracePlugin', tracePlugin);
RefClient.mapPlugin.register('routeImportAddVia', addViaPlugin);
